import { Controller } from 'stimulus'
import Flickity from 'flickity'

export default class CarouselController extends Controller {
  connect() {
    this.flickity = new Flickity(this.element, {
      cellAlign: "left",
      contain: true,
      wrapAround: false,
      pageDots: false,
      prevNextButtons: false,
      pauseAutoPlayOnHover: false,
      selectedAttraction: 0.01,
      friction: 0.2,
      autoPlay: 5000
    })
  }

  disconnect() {
    this.flickity.destroy()
  }
}